/* Gallery lightbox / carousel — vanilla JS, no dependencies.
   Click (or Enter/Space) a gallery photo to open a full-size preview.
   Navigate with arrows, keyboard (← → Esc), or swipe on touch. */
(function () {
  var figures = Array.prototype.slice.call(
    document.querySelectorAll('.gallery-grid figure')
  );
  if (!figures.length) return;

  var items = figures.map(function (fig) {
    var img = fig.querySelector('img');
    var cap = fig.querySelector('figcaption');
    return {
      src: img.getAttribute('data-full') || img.getAttribute('src'),
      alt: img.getAttribute('alt') || '',
      caption: cap ? cap.textContent : ''
    };
  });

  var index = 0;
  var lastFocus = null;

  var lb = document.createElement('div');
  lb.className = 'lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Gallery image viewer');
  lb.innerHTML =
    '<button class="lb-close" type="button" aria-label="Close viewer">✕</button>' +
    '<button class="lb-btn lb-prev" type="button" aria-label="Previous image">‹</button>' +
    '<figure><img alt=""><figcaption></figcaption></figure>' +
    '<button class="lb-btn lb-next" type="button" aria-label="Next image">›</button>' +
    '<div class="lb-count" aria-hidden="true"></div>';
  document.body.appendChild(lb);

  var lbImg = lb.querySelector('img');
  var lbCap = lb.querySelector('figcaption');
  var lbCount = lb.querySelector('.lb-count');

  function render() {
    var it = items[index];
    lbImg.setAttribute('src', it.src);
    lbImg.setAttribute('alt', it.alt);
    lbCap.textContent = it.caption;
    lbCount.textContent = index + 1 + ' / ' + items.length;
    // warm the neighbours so next/prev is instant
    [index + 1, index - 1].forEach(function (n) {
      var im = new Image();
      im.src = items[(n + items.length) % items.length].src;
    });
  }

  function open(i) {
    index = i;
    lastFocus = document.activeElement;
    render();
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    lb.querySelector('.lb-next').focus();
  }

  function close() {
    lb.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function go(delta) {
    index = (index + delta + items.length) % items.length;
    render();
  }

  figures.forEach(function (fig, i) {
    fig.setAttribute('tabindex', '0');
    fig.setAttribute('role', 'button');
    fig.setAttribute('aria-label', 'View larger: ' + items[i].caption);
    fig.addEventListener('click', function () {
      open(i);
    });
    fig.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open(i);
      }
    });
  });

  lb.querySelector('.lb-close').addEventListener('click', close);
  lb.querySelector('.lb-prev').addEventListener('click', function () {
    go(-1);
  });
  lb.querySelector('.lb-next').addEventListener('click', function () {
    go(1);
  });
  lb.addEventListener('click', function (e) {
    if (e.target === lb) close();
  });

  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
  });

  var startX = 0;
  lb.addEventListener(
    'touchstart',
    function (e) {
      startX = e.touches[0].clientX;
    },
    { passive: true }
  );
  lb.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
  });
})();
